import PropTypes from 'prop-types';
import React from 'react';

import FileBrowserActions from 'file-browser/FileBrowserActions';
import MetadataTabState from 'metadata/MetadataTabState';

interface RegistryValidatorFileCellProps {
  fileId: string;
  name: string;
  isLinkedFile: boolean;
  onFileClick: () => void;
}
/*
 * Renders a link with file's name and an edit icon, which opens the file's MetadataTab on click.
 */
class RegistryValidatorFileCell extends React.Component<RegistryValidatorFileCellProps> {
  static propTypes = {
    fileId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isLinkedFile: PropTypes.bool.isRequired,
    onFileClick: PropTypes.func.isRequired,
  };

  _handleClick: () => void = () => {
    // Open the metadata tab and close the modal on click.
    FileBrowserActions.openFile(this.props.fileId, {
      onOpen: (fileState) => {
        fileState!.activateTab(MetadataTabState);
      },
    });
    this.props.onFileClick();
  };

  override render(): JSX.Element {
    return (
      <div onClick={this._handleClick}>
        <a>{this.props.name}</a>
        {this.props.isLinkedFile && <div className="registerModal-file-subtitle">Linked file</div>}
      </div>
    );
  }
}

export default RegistryValidatorFileCell;
